import React, { useState } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";
import { Field, Control, Label } from "rbx";
import { BooleanInput } from "../../../components/inputs";
import {
  SystemCodeCategorySelect,
  SystemCodeCodeNameSelect
} from "../../../components/SystemCodes";
import FilterButtons from "../../../components/FilterButtons";
import { ALL_SYSTEM_CODES_QUERY } from "../../../graphql/SystemCodes/SystemCodes.graphql";

const INITIAL_FILTER_STATE = {
  Active: true
};

function SystemCodeFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });
  const CodeNames = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {},
      orderBy: "CodeDescription_DESC",
      orderByMulti: ["CodeName_ASC"]
    }
  });
  const handleChange = e => {
    const updates = { ...inputs };
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (
      e.target.name === "CodeName" &&
      (!inputs.Category || inputs.Category === "0")
    ) {
      const code = CodeNames.data.SystemCodes.find(c => c.CodeName === value);
      updates.Category = code?.Category || null;
    } else if (e.target.name === "Category" && inputs.CodeName) {
      updates.CodeName = "0";
    }
    setInputs({ ...updates, [e.target.name]: value });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));
  const handleCancel = () => onClose(onFilter(filters));

  console.log({ inputs });
  return (
    <div style={{ width: "500px", minWidth: "500px" }}>
      <Field kind="group">
        <Control style={{ width: "45%" }}>
          <Label>Category</Label>
          <SystemCodeCategorySelect
            label="Category"
            name="Category"
            orderByMulti={["Category_ASC"]}
            value={inputs.Category}
            where={{ Type: "User" }}
            onChange={handleChange}
          />
        </Control>
        <Control style={{ width: "45%" }}>
          <Label>Code Name</Label>
          <SystemCodeCodeNameSelect
            label="Code Name"
            name="CodeName"
            value={inputs.CodeName}
            where={
              inputs.Category !== "0" || !inputs?.Category
                ? {
                    Type: "User",
                    Category: inputs.Category
                  }
                : {
                    Type: "User"
                  }
            }
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
SystemCodeFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};

export default SystemCodeFilters;
